import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

export const SessionGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 24px;
  width: 100%;
  align-items: start;
`;

export const SessionCard = styled.div`
  background-color: ${props => props.$isSelected ? '#EFF6FF' : '#f8f9fa'};
  border-radius: 4px;
  border: 1px solid ${props => props.$isSelected ? '#93C5FD' : '#e0e0e0'};
  transition: all 0.2s;
  align-self: start;
  position: relative;
  cursor: ${props => props.$selectable === "true" ? 'pointer' : 'default'};
  box-shadow: ${props => props.$isSelected ? '0 2px 8px rgba(59, 130, 246, 0.15)' : 'none'};

  &:hover {
    background-color: ${props => props.$isSelected ? '#DBEAFE' : props.$selectable === "true" ? '#f1f3f5' : '#f8f9fa'};
    border-color: ${props => props.$isSelected ? '#60A5FA' : props.$selectable === "true" ? '#bdbdbd' : '#e0e0e0'};
  }
`;

export const SelectionIndicator = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${props => props.$isSelected ? '#3B82F6' : 'white'};
  border: 2px solid ${props => props.$isSelected ? '#3B82F6' : '#CBD5E1'};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

export const StatusChip = styled.div`
  position: absolute;
  top: 16px;
  right: 44px;
`;

export const SessionCardContent = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-height: 180px;
`;

export const SessionTitle = styled.div`
  margin: 0;
  font-weight: 600;
  color: ${COLORS.PRIMARY};
  margin-bottom: 8px;
  font-size: 16px;
  padding-right: ${props => props.$selectable === "true" ? '28px' : '0'}; /* Padding when selectable */
  padding-left: 0; /* Removed left padding since selection indicator moved to right */
`;

export const BusinessUnitName = styled.div`  
  color: #64748B;
  font-size: 14px;
  margin-bottom: 16px;
`;

export const SessionDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: auto;
`;

export const DetailRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #475569;
  font-size: 14px;

  svg {
    color: #94A3B8;
    font-size: 16px;
  }
`;